import * as React from 'react';
import Login from 'components/login';
import Main from 'components/main';
import ForgotPassword from 'components/forget-password/forget-password';
import ResetPassword from 'components/forget-password/reset-password';
import { Redirect, Route, Switch } from 'react-router-dom';
import merchantContract from './legals/merchant_contract';
import PDFEmbedded from './pdf';
import FormSubmit from 'components/form-submit/router';
import qs from 'query-string';
import helpApp from './help-app';

const Routes = () => (
  <Switch>
    <Route exact path="/" component={Login} />
    <Route exact path="/login" component={Login} />
    <Route path="/main/:component*" component={Main} />
    <Route path="/:merchantId/main/:component*" component={Main} />
    <Route path="/forget-password" component={ForgotPassword} />
    <Route path="/form-submit" component={FormSubmit} />
    <Route path="/app/help" component={helpApp} />
    <Route path="/reset-password/:key" component={ResetPassword} />
    <Route
      path="/merchant-contract"
      render={() => <PDFEmbedded url={`${location.protocol}//${location.host}${merchantContract}`} />}
    />
    <Route
      path="/pdf"
      render={({ location: { search } }) => {
        const path = qs.parse(search)['path'] as string | undefined;
        return path ? <PDFEmbedded url={path} /> : null;
      }}
    />
    <Route render={() => <Redirect to={'/'} />} />
  </Switch>
);

export default Routes;
